import { render, staticRenderFns } from "./documents.pp36NTST.vue?vue&type=template&id=7a45bf07&scoped=true"
import script from "./documents.pp36NTST.vue?vue&type=script&lang=js"
export * from "./documents.pp36NTST.vue?vue&type=script&lang=js"
import style0 from "./documents.pp36NTST.vue?vue&type=style&index=0&id=7a45bf07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45bf07",
  null
  
)

export default component.exports